export const Constants = {
  configuration: 'Configurações',
  maintenance: 'Período de manutenção (indisponibilidade)',
  isActive: 'Período ativo',
  beggining: 'Início',
  ending: 'Final',
  save: 'salvar',
  cancel: 'cancelar',
  password: 'Senha',
  changePassword: 'alterar senha',
};
